import React, { useEffect, useState, Fragment, useContext } from "react";
import { Link, NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { base_url } from "../Api/Api";
import Skeleton from "@material-ui/lab/Skeleton";
import Popup from "../Common/Popup";
import Search from "../search/search";
import DropDown from "./Dropdown";
import NotificationList from "./notification/NotificationList";
import Dropdown from "react-bootstrap/Dropdown";
import { AppContext } from "../../layout/AppContext";
import Cookies from "universal-cookie";

const MainMenu = (props) => {
  const { contextStore, setContextStore } = useContext(AppContext);
  const [statusShow, setStatusShow] = useState(true);
  const [state, setState] = useState({
    data: [],
    searchStatus: false,
    notifStatus: false,
    unreadNotification: false,
  });

  useEffect(() => {
    // if (statusShow && cookies.get("api_key") !== null) {

    base_url
      .get("splash")
      .then((response) => {
        let fullName =
          response.data.profile.name + " " + response.data.profile.last_name;
        let image = response.data.profile.profile_photo_url;
        localStorage.setItem("nameTiket", JSON.stringify(fullName));
        localStorage.setItem("imageTiket", JSON.stringify(image));
        localStorage.setItem(
          "unreadNotification",
          response.data.unread_notifications === 0 ? false : true
        );

        setState({
          ...state,
          data: response.data.profile,
          unreadNotification:
            response.data.unread_notifications === 0 ? false : true,
        });
        setContextStore({
          ...contextStore,
          userScore: response.data.profile.score || 0,
        });
        setStatusShow(false);
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
          }
        }
      });
    // }
  }, []);

  useEffect(() => {}, [contextStore.userScore]);

  const togglePopup = (status) => {
    setState({
      ...state,
      searchStatus: status,
    });
  };

  const toggleDropdown = (status) => {
    localStorage.setItem("unreadNotification", false);

    setState({
      ...state,
      notifStatus: status,
      unreadNotification: false,
    });
  };

  const closeAccount = () => {
    const cookies = new Cookies()
    cookies.remove("api_key")
    localStorage.clear();
    props.history.push(`/`);
    // window.location.reload()
  };
  const cookies = new Cookies()
  return (
    <Fragment>
      {props.match.path === "/" && !cookies.get("api_key") ? (
        <Fragment />
      ) : (
        <Fragment>
          <div id="head1" className="main-header">
            <Popup
              active={state.searchStatus}
              overlayClickAble={true}
              closePopup={() => togglePopup(false)}
            >
              <Search popupStatus={() => togglePopup()} />
            </Popup>
            <div className="main-headers contain">
              <div className="main-logo">
                <Link to="/">
                  <img src="/svg/logo.svg" />
                </Link>
              </div>
              <div className="nav-info">
                <Button
                  variant="contained"
                  className="nav-icon"
                  onClick={() => togglePopup(true)}
                >
                  <i className="icon-search" />
                </Button>
                <div className="btn-notif">
                  <Button
                    variant="contained"
                    className="nav-icon"
                    onClick={() => toggleDropdown(true)}
                  >
                    <b
                      className={
                        localStorage.getItem("unreadNotification") === true ||
                        state.unreadNotification
                          ? "active"
                          : ""
                      }
                    ></b>
                    <i className="icon-alarm" />
                  </Button>
                  <DropDown
                    active={state.notifStatus}
                    class="notifications"
                    closePopup={() => toggleDropdown(false)}
                  >
                    <NotificationList
                      active={state.notifStatus}
                      closePopup={() => toggleDropdown(false)}
                    />
                  </DropDown>
                </div>
                <div className="user">
                  <Dropdown>
                    {state.data == undefined || state.data.length === 0 ? (
                      <div className="skltn">
                        <Skeleton
                          animation="wave"
                          variant="rect"
                          width={40}
                          height={40}
                        />
                        <Skeleton
                          animation="wave"
                          variant="rect"
                          width={100}
                          height={24}
                        />
                      </div>
                    ) : (
                      <Fragment>
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-account"
                        >
                          <img
                            src={
                              state.data.length == 0
                                ? ""
                                : state.data.profile_photo_url
                            }
                          />
                          <span>
                            {state.data.length == 0
                              ? ""
                              : state.data.name + " " + state.data.last_name}
                          </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Button variant="contained">
                            <Link to="/profile/EditInformation">
                              {" "}
                              ویرایش حساب کاربری{" "}
                              <i className="icon-edit-11"></i>
                            </Link>
                          </Button>
                          <Button variant="contained" onClick={closeAccount}>
                            خروج از حساب کاربری{" "}
                            <i className="icon-logout-31"></i>
                          </Button>
                        </Dropdown.Menu>
                      </Fragment>
                    )}
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <div id="head2" className="main-menu contain">
            <div className="menu-items">
              <NavLink exact to="/">
                <div className="btn-base btn-transparent">
                  <Button variant="contained">صفحه اصلی</Button>
                </div>
              </NavLink>
              <NavLink to="/education">
                <div className="btn-base btn-transparent">
                  <Button variant="contained">آموزش</Button>
                </div>
              </NavLink>
              <NavLink to="/news">
                <div className="btn-base btn-transparent">
                  <Button variant="contained">اخبار</Button>
                </div>
              </NavLink>
              <NavLink to="/award">
                <div className="btn-base btn-transparent">
                  <Button variant="contained">جایزه</Button>
                </div>
              </NavLink>
              <NavLink to="/profile">
                <div className="btn-base btn-transparent">
                  <Button variant="contained">پروفایل</Button>
                </div>
              </NavLink>
              <NavLink to="/about-us">
                <div className="btn-base btn-transparent">
                  <Button variant="contained">درباره ما</Button>
                </div>
              </NavLink>
              <NavLink to="/contact-us">
                <div className="btn-base btn-transparent">
                  <Button variant="contained">تماس با ما</Button>
                </div>
              </NavLink>
              <NavLink to="/roles">
                <div className="btn-base btn-transparent">
                  <Button variant="contained">قوانین و مقررات</Button>
                </div>
              </NavLink>
            </div>
            <div className="my-scores">
              <div>
                <span>امتیازات من :</span>
                <span>
                  <i className="icon-black-star-silhouette" />
                  {contextStore.userScore || 0}
                </span>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default withRouter(MainMenu);
